
import {useHead} from '@vueuse/head'
import CustomPageBuilder from "./custompagebuilder/CustomPageBuilder.vue"
import SidebarLayout from '../layouts/SidebarLayout.vue'
import {computed, defineComponent, reactive} from "vue";

import VButton from '../components/base/button/VButton.vue'
import {useToggle} from '@vueuse/core'
import {mapState} from "vuex";

export default defineComponent({
  name: 'Login',
  components: {
    VButton,
    CustomPageBuilder,
    SidebarLayout
  },
  setup() {
    const siteData = reactive({
      title: `JB Drax Honoré Strategies`
    })
    const LoggedIn = reactive({
      LoggedIn: localStorage.isLoggedIn
    })
    useHead({
// Can be static or computed
      title: computed(() => siteData.title),
    })
    useToggle(false)

  },
  computed: {
    ...mapState(['user'])
  },


})


